import { String } from "lodash";

export interface Coleta {
  id: number;
  titulo: string;
  descricao: string;
  tipo: string;
  ordem: number;
  atributos: any[];
  grupos: Coleta[];
  campos: Campo[];
}

export interface Campo {
  id?: number;
  titulo?: string;
  descricao?: string;
  codigo?: string;
  tipo?: string;
  opcoes?: Opcoe[];
  atributos?: Atributo[];
  dependentes?: Dependente[];
  respostas?: Resposta[];
}

export interface Atributo {
  id: number;
  propriedade: string;
  configuracao: string;
  valor: string;
}

export interface Resposta {
  valor: string;
  processo: number;
  etapa: number;
  ordem: number;
  pdf: boolean;
}

export interface Dependente {
  id: number;
  campoDependenteCodigo: string;
  acao: Acao;
  operacao: Operacao;
  valorEsperado: string;
}

export enum Acao {
  Obrigar = 'OBRIGAR',
}

export enum Operacao {
  Igual = 'IGUAL',
}

export interface Opcoe {
  titulo: string;
  valor: string;
  tipo: Tipo;
  condicao: null | string;
  ativo: boolean | undefined;
  distanciaEmMetros?: number;
}

export enum Tipo {
  Derivado = 'DERIVADO',
  Estatico = 'ESTATICO',
}


/* Models de proposta */
export interface Proposta {
  id: string;
  cliente: Cliente;
  origemComercial: number;
  etapaAtual: EtapaAtual;
  produto: number;
  status: StatusProposta;
  documentos: PropostaDocumento[];
  data: Date;
  usuario: number;
  marcadores: number[];
  observacao?: string;
  fluxo: number;
  reenviosSmsTac: number;
  retomada?: boolean;
}

export enum StatusProposta {
  EM_ANDAMENTO = 'EM_ANDAMENTO',
  APROVADO = 'APROVADO',
  REPROVADO = 'REPROVADO',
  INCONSISTENTE = 'INCONSISTENTE',
  ERRO_GERACAO_TAC = 'ERRO_GERACAO_TAC',
  ERRO_CADASTRO_PROCESSADORA = 'ERRO_CADASTRO_PROCESSADORA',
  EXPIRADO = 'EXPIRADO',
}


export interface Cliente {
  documento: string;
  nome: string;
}

export interface EtapaAtual {
  id: number;
  status: StatusEtapa;
  observacao: string;
  tipo: string;
  codigo: CodigoEtapa;
  nome: string;
  /**
   * @description Id da etapa do fluxo.
   */
  configuracao: number;
  coleta: number;
  exibeMarcador: boolean;
  tipoColeta: string;
}

export enum StatusEtapa {
  INICIADO = 'INICIADO',
  PREENCHIMENTO = 'PREENCHIMENTO',
  EM_ANALISE = 'EM_ANALISE',
  FINALIZADO = 'FINALIZADO',
  INCONSISTENTE = 'INCONSISTENTE',
}

export enum CodigoEtapa {
  NEUROTECH = 'NEUROTECH',
  CREDDEFENSE = 'CREDDEFENSE',
  CARDS = 'CARDS',
  MESA = 'MESA',
  B2E = 'B2E',
  SERPRO = 'SERPRO',
  ACESSO_DIGITAL = 'ACESSO_DIGITAL',
  CAPTACAO = 'CAPTACAO',
}

export enum TipoColeta {
  PADRAO = "PADRAO",
  CORRECAO = "CORRECAO"
}

export function codigoEtapaValido(codigo: CodigoEtapa): boolean {
  return codigo in CodigoEtapa;
}

export interface PropostaDocumento {
  id: number;
  tipo: string;
}

export interface CampoCaptura {
  id: number;
  base64: string;
  isPdf: boolean;
}